export default {
    response_100: 'Not high risk',
    response_101:
        'High risk (pregnant OR current smoker (currently smokes every day or some days) OR at least one underlying condition OR age 65+)',
    response_1099: 'DTR/Unknown',

    response_200: 'Not current smoker',
    response_201: 'Current smoker (Every day or some days)',
    response_2099: 'DTR/Unknown',

    response_300: 'No underlying health condition',
    response_301: 'Known to have any underlying health condition',
    response_3099: 'DTR/Unknown',

    response_400: 'Under 65 years of age',
    response_401: '65+ years of age',
    response_4099: 'DTR/Unknown',

    response_500: 'Do not plan to receive flu vaccine this season',
    response_501: 'Received flu vaccine this season',
    response_502: 'Plan to receive flu vaccine this season',
    response_5099: 'DTR/Unknown',

    response_600: 'Definitely do not plan to receive COVID-19 vaccine',
    response_601: 'Received all COVID-19 vaccine doses',
    response_602: 'Received partial COVID-19 vaccine doses',
    response_603: 'Definitely plan to receive COVID-19 vaccine',
    response_604: 'Probably plan to receive COVID-19 vaccine',
    response_605: 'Probably do not plan to receive COVID-19 vaccine',
    response_606: 'Received partial COVID-19 vaccine, plan to complete',
    response_607: 'Received partial COVID-19 vaccine, do not plan to complete',
    response_608: 'No COVID-19 vaccine received, but plan to complete',
    response_609: 'No COVID-19 vaccine received, do not plan to complete',
    response_6099: 'DTR/Unknown',

    response_700:
        'Reported taking part in activities other than grocery shopping/visiting pharmacy outside of the home in past 7 days',
    response_701:
        'Reported only grocery shopping or visiting the pharmacy outside of the home in past 7 days',
    response_7088: 'Question not included in questionnaire (Safe behaviors)',
    response_7099: 'DTR/Unknown',

    response_800: 'Did not report practicing all safe behaviors in past 7 days',
    response_801:
        'Reported practicing all safe behaviors in past 7 days (Always or frequently wears mask, cleans living/workspace, covers cough, maintains 6 ft of distance, and wears mask)',
    response_8088: 'Question not included in questionnaire (Stayed home)',
    response_8099: 'DTR/Unknown',

    response_901: 'Uses facemask (past 7 days): Always',
    response_902: 'Uses facemask (past 7 days): Sometimes',
    response_903: 'Uses facemask (past 7 days): Never',
    response_904: 'Uses facemask (past 7 days): Not applicable',
    response_9088: 'Question not included in questionnaire (Face mask)',
    response_9099: 'DTR/Unknown',

    response_1001: 'Wash hands (past 7 days): Frequently',
    response_1002: 'Wash hands (past 7 days): Sometimes',
    response_1003: 'Wash hands (past 7 days): Never',
    response_1004: 'Wash hands (past 7 days): Not applicable',
    response_10088: 'Question not included in questionnaire (Wash hands)',
    response_10099: 'DTR/Unknown',

    response_1101: 'Cleans or disinfects living/workspace (past 7 days): Frequently',
    response_1102: 'Cleans or disinfects living/workspace (past 7 days): Sometimes',
    response_1103: 'Cleans or disinfects living/workspace (past 7 days): Never',
    response_1104: 'Cleans or disinfects living/workspace (past 7 days): Not applicable',
    response_11088: 'Question not included in questionnaire (Clean space)',
    response_11099: 'DTR/Unknown',

    response_1201: 'Temperature < 100.4 °F',
    response_1202: 'Temperature 100.4 - 103.9 °F',
    response_1203: 'Temperature >= 104 °F',
    response_12099: 'DTR/Unknown',

    response_1300: 'No symptoms',
    response_1301: 'One symptom',
    response_1302: '2+ symptoms',
    response_13099: 'DTR/Unknown',

    response_1401: 'Blood Oxygen Saturation < 94',
    response_1402: 'Blood Oxygen Saturation >= 94',
    response_14099: 'DTR/Unknown',
};
